import { Hypothesis } from "lib/models-struc/hypothesis/hypothesis";

export enum AnalysisActionType {
  SOLVE_ANALYSIS,
}

export type AnalysisAction = {
  type: AnalysisActionType.SOLVE_ANALYSIS;
  payload: { hypothesisSet: Hypothesis[] }
}; 